import React, { useState } from 'react';
import '../assets/css/LoginScreen.css';
import background from '../assets/img/Login.jpg';
import logo from '../assets/img/logo.png';
import api from '../api/Api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";


const LoginScreen = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Limpa o erro quando o usuário começar a digitar
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const validateForm = () => {
    const newErrors = {
      email: '',
      password: ''
    };

    if (!formData.email) {
      newErrors.email = 'E-mail é obrigatório';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'E-mail inválido';
    }

    if (!formData.password) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
    }

    setErrors(newErrors);
    return !newErrors.email && !newErrors.password;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      setLoading(true);
      
      
      try {
            localStorage.removeItem("token");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("perfil");
        const dados = { email: formData.email, password: formData.password };
        const response = await api.Login(dados);
        
        localStorage.setItem("token", JSON.stringify(response.user));
        localStorage.setItem("loginTime", Date.now());

        localStorage.setItem("perfil", response.user.perfil);
    

        if(response.success){

        toast.success('Login feito com sucesso');

         setTimeout(() => {
        navigate("/dashboard");
        }, 2000);
        }
    
      else if(response.message==='Recuperar')
      {
        toast.error('Recuperar senha');
      }
      else{
         toast.error(response.message);
      }

        
      } catch (error) {
      
         toast.error(error.response?.data?.message || 'Erro ao fazer login. Tente novamente.');
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="login-container">
      <ToastContainer position="top-right" />
      <div 
        className="background-image"
        style={{ backgroundImage: `url(${background})` }}
      ></div>
      <div className="login-overlay"></div>
      
      <div className="login-card">
        {/* Logo da empresa */}
        <div className="logo-container">
          <div className="company-logo">
            <img 
              src={logo} 
              alt="Logo da Empresa" 
              className="logo-image"
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="login-form" noValidate>
          <div className="input-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="E-mail"
              className={`login-input ${errors.email ? 'error' : ''}`}
              disabled={loading}
            />
            <div className={`input-underline ${errors.email ? 'error' : ''}`}></div>
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

         <div className="input-group password-group">
  <input
    type={showPassword ? "text" : "password"}
    name="password"
    value={formData.password}
    onChange={handleChange}
    placeholder="Senha"
    className={`login-input ${errors.password ? 'error' : ''}`}
    disabled={loading}
  />
  <span
    className="toggle-password"
    onClick={() => setShowPassword(!showPassword)}
  >
      {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
  </span>
  <div className={`input-underline ${errors.password ? 'error' : ''}`}></div>
  {errors.password && <span className="error-message">{errors.password}</span>}
</div>


          <button 
            type="submit" 
            className={`login-button ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
                <span>CARREGANDO...</span>
              </div>
            ) : (
              <>
                <span className="button-text">LOGIN</span>
                <div className="button-glow"></div>
              </>
            )}
          </button>

          <div className="login-footer">
            <a href="#" className="forgot-password">Esqueceu a senha?</a>
          </div>
        </form>
      </div>

      {/* Efeitos de fundo minimalistas */}
      <div className="background-effects">
        <div className="grid-lines"></div>
      </div>
    </div>
  );
};

export default LoginScreen;